/**
 * @file Products.
 */

import KeenSlider from 'keen-slider';

/**
 * Products.
 */
const vProducts = () => {
	const productSection = document.querySelector('.v-products');
	if (!productSection) return;
	const slides = productSection.querySelectorAll('.v-products__item');
	const arrows = document.querySelectorAll('.v-products__arrow');

	const keen = new KeenSlider('.v-products__list', {
		slides: {
			perView: Math.min(4, slides.length),
			spacing: 10,
		},
		drag:        false,
		loop:        false,
		breakpoints: {
			'(max-width: 1150px)': {
				slides: {
					perView: Math.min(3, slides.length),
					spacing: 10,
				},
			},
			'(max-width: 900px)': {
				slides: {
					perView: Math.min(2, slides.length),
					spacing: 10,
				},
			},
			'(max-width: 650px)': {
				slides: {
					perView: 1,
					spacing: 10,
					origin:  0,
				},
			},
		},
	});

	/**
	 * Set visible slides w/ correct tab focus and aria.
	 */
	const setVisibleSlides = () => {
		slides.forEach((slide) => { slide.setAttribute('aria-hidden', 'true'); slide.querySelector('.v-products__link').setAttribute('tabindex', -1); });
		const visibleSlides = [];
		for (let i = 0; i < keen.options.slides.perView; i++) {
			visibleSlides.push(slides[keen.track.absToRel(keen.track.details.abs + i)]);
		}
		visibleSlides.forEach((slide) => { slide.setAttribute('aria-hidden', 'false'); slide.querySelector('.v-products__link').removeAttribute('tabindex'); });
	};

	keen.on('slideChanged', setVisibleSlides);
	keen.on('detailsChanged', setVisibleSlides);
	setVisibleSlides();

	/**
	 * Set arrows to disabled if # of slides equals perView.
	 */
	const toggleArrows = () => {
		if (keen.options.slides.perView === slides.length) {
			[...arrows].forEach((a) => {
				a.classList.add('v-products__arrow--disabled');
				a.setAttribute('disabled', '');
			});
		} else {
			[...arrows].forEach((a) => {
				a.classList.remove('v-products__arrow--disabled');
				a.removeAttribute('disabled');
			});
		}
	};
	keen.on('detailsChanged', toggleArrows);
	toggleArrows();

	/**
	 * Focus the current slide.
	 */
	const setSlideFocus = () => {
		slides[keen.track.details.rel].querySelector('.v-products__link').focus();
	};
	keen.on('slideChanged', setSlideFocus);

	[...arrows].forEach((a) => {
		a.addEventListener('click', () => {
			let current = keen.track.details.abs;

			if (a.dataset.keenDir === '<') {
				current--;
				if (current < 0) {
					current = slides.length - keen.options.slides.perView;
					keen.moveToIdx(slides.length - keen.options.slides.perView, true);
				} else {
					keen.prev();
				}
			} else {
				current++;
				if (current + (keen.options.slides.perView - 1) === slides.length) {
					current = 0;
					keen.moveToIdx(0, true);
				} else {
					keen.next();
				}
			}
		});
	});
};

export default vProducts;
